const translations = {
  triggers: 'Gatilhos',
  scheduledFor: 'Agendada para',
  open: 'Aberto',
  sla: 'SLA',
  'filters.statusReasons': 'Motivos do status',
  'filters.statusReason': 'Motivos do status',
  'filters.place': 'Destino',
  'filters.semaphore': 'Semáforo',
  'filters.selectSemaphore': 'Seleção de semáforo',
  'filters.dates': 'Datas',
  'filters.createdBy': 'Criado por',
  'filters.externalValue': 'Valor externo',
  'filters.containsInName': 'Contém no nome',
  anonymousResponse: 'Respondido anonimamente',
  selectUser: 'Selecionar usuário',
  selectTag: 'Selecionar tag',
  'dateOptions.overdue6Plus': 'Vencido há 6+ dias',
  'dateOptions.overdue2to5': 'Vencido há 2-5 dias',
  'dateOptions.overdue1': 'Vencido há 1 dia',
  'dateOptions.dueToday': 'Vencimento hoje',
  'dateOptions.dueTomorrow': 'Vencimento amanhã',
  'dateOptions.due2to5': 'Vencimento em 2-5 dias',
  'dateOptions.due6to10': 'Vencimento em 6-10 dias',
  'dateOptions.due11to15': 'Vencimento em 11-15 dias',
  'dateOptions.due16to30': 'Vencimento em 16-30 dias',
  'dateOptions.due60Plus': 'Vencimento em 60+ dias',
  'slaValue.days': 'Dias',
  'slaValue.hours': 'Horas',
  'slaValue.minutes': 'Minutos',
  'slaType.creationDate': 'Data de abertura',
  'slaType.schedulingDate': 'Data de agendamento',
  'priority.critical': 'Crítica',
  'priority.high': 'Alta',
  'priority.medium': 'Média',
  'priority.low': 'Baixa',
  'cardPicker.selected': 'Selecionado',
  'cardPicker.selectOne': 'Selecione um',
  'types.root': 'Atividades de primeiro nível',
  'types.actionPlan': 'Planos de ação',
  defaultLabel: 'Atividades'
}

export default translations
